const data = [
  { id: 1, link: '#', title: 'Home' },
  { id: 4, link: '#portfolio', title: 'Lokasi' },
  { id: 5, link: '#contact', title: 'Contact' },

];

export default data;
